export const seoObject = {
  base: {
    title: "Wallet Management Service",
    description: "Wallet Management Service"
  },
  home: {
    title: "Home",
    description: "Wallet Management Service"
  },
  cardschemes: {
    title: "Card Schemes",
    description: "Manage Card Schemes"
  },
  cardtypes: {
    title: "Card Types",
    description: "Manage Card Types"
  },
  cardissuers: {
    title: "Card Issuers",
    description: "Manage Card Issuers"
  },
  idtypes: {
    title: "Identification Types",
    description: "Manage Identification Types"
  },
  domains: {
    title: "Domains",
    description: "Manage Domains"
  },
  institutions: {
    title: "Institutions",
    description: "Manage Institutions"
  },
  currencies: {
    title: "Currencies",
    description: "Manage Currencies"
  },
  clients: {
    title: "Clients",
    description: "Manage Clients"
  },
  configs: {
    title: "Configurations",
    description: "Manage Configurations"
  },
  notfound: {
    title: "Page not found",
    description: "Error: Page not found"
  }
};
